import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <>
        <footer class="bg-dark">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-lg-4 mb-2-5 mb-lg-0">
                        <a href="!#" class="footer-logo">
                            <img src="img/logos/logo.svg" class="mb-4" alt="Footer Logo" />
                        </a>
                        <ul class="social-icon-style1 gap-2 d-flex">
                            <li><Link class="fab fa-facebook-f"></Link></li>
                            <li><Link><i class="fab fa-twitter"></i></Link></li>
                            <li><Link><i class="fab fa-youtube"></i></Link></li>
                            <li><Link><i class="fab fa-linkedin-in"></i></Link></li>
                        </ul>                      
                    </div>
                    <div class="col-md-6 col-lg-4 mb-2-5 mb-lg-0">
                        <div class="ps-md-1-6 ps-lg-1-9">
                            <ul class="footer-list">
                                <li><Link to={'/About'}>About MGIMS</Link></li>
                                <li><Link to={'/OurManagement'}>Our Management</Link></li>
                                <li><Link to={'/Administrative'}>Administrative Committee</Link></li>
                                <li><Link to={'/FunctionsEvents'}>Functions & Events</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-4 mb-2-5 mb-md-0">
                        <div class="ps-lg-1-9 ps-xl-2-5">
                             <ul class="footer-list">
                                <li><Link to={'/OurFacilities'}>Our Facilities</Link></li>
                                <li><Link to={'/Course'}>Course</Link></li>
                                <li><Link to={'/Departments'}>Our Departments</Link></li>
                                <li><Link to={'/Contact'}>Contact Us</Link></li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
                <div class="footer-bar text-center">
                    <p class="mb-0 text-white font-weight-500">&copy; <span class="current-year"></span> MGIMS Lucknow 2024. All Rights Reserved. Powered by <a href="https://adventusindia.com/" class="text-secondary" target='blank'>Adventus</a></p>
                </div>
            </div>
        </footer>
    </>
  )
}

export default Footer
